import { Play } from 'lucide-react'
import type { MetaAd } from '@storefronts/common-types'
import { HoverCard, HoverCardTrigger } from '@/components/ui/hover-card'
import { cn } from '@/lib/utils'
import { MetaAdCreativeHoverContent } from './MetaAdCreativeHoverContent'
import { getMetaAdBestImageUrl, getMetaAdVideoUrl } from './metaAdCreativeUtils'

interface AdCreativeMediaProps {
    ad: MetaAd
    className?: string
}

export function AdCreativeMedia({ ad, className }: AdCreativeMediaProps) {
    const imageUrl = getMetaAdBestImageUrl(ad)
    const videoUrl = getMetaAdVideoUrl(ad)

    if (!imageUrl) {
        return null
    }

    return (
        <HoverCard openDelay={200}>
            <HoverCardTrigger asChild>
                <div
                    className={cn(
                        'relative size-full overflow-hidden bg-muted',
                        className,
                    )}
                >
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img
                        src={imageUrl}
                        alt={ad.name}
                        loading="lazy"
                        className="size-full object-cover transition-transform duration-300 ease-out group-hover:scale-110"
                    />
                    {videoUrl && (
                        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
                            <div className="rounded-full p-2 bg-black/55">
                                <Play className="size-4 fill-white text-white" />
                            </div>
                        </div>
                    )}
                </div>
            </HoverCardTrigger>
            <MetaAdCreativeHoverContent ad={ad} />
        </HoverCard>
    )
}
